var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-footer"},[_c('div',[_vm._v("Copyright © Antoine Poirrier. Tout droits réservés")])])}]

export { render, staticRenderFns }